import type { AsyncHasMany } from '@ember-data/model';
import Model, { attr, hasMany } from '@ember-data/model';
import type ProductModel from './product';
import type ActionModel from './action';

export default class FormatorModel extends Model {
  @attr() declare name: string;
  @hasMany('product', { async: true })
  declare products: AsyncHasMany<ProductModel>;
  @hasMany('action', { async: true })
  declare actions: AsyncHasMany<ActionModel>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    formator: FormatorModel;
  }
}
